var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/importErrorMessageMap.ts";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
export var bimFileErrorMessageMap = function bimFileErrorMessageMap(bimFileErrorEvent) {
  return bimFileErrorEvent.map(function (data) {
    if ('errorCode' in data && data.errorCode) {
      return {
        text: importErrorNotifierCodeMap[data.errorCode],
        name: data.name,
        version: data.versionId
      };
    }

    return null;
  });
};
export var importErrorNotifierCodeMap = {
  AxisError: 'Модель не содержит элементов. Пожалуйста, внесите изменения в модель и попробуйте еще раз.',
  Role3DError: 'Не настроен 3D вид для модели. Пожалуйста, внесите изменения в модель и попробуйте еще раз.',
  StructureError: 'Неправильная структура модели. Должна быть: категория/семейство/типоразмер/элемент (вложенный элемент). Пожалуйста, внесите изменения в модель и попробуйте еще раз.',
  ForgeError: 'Ошибка импорта, пожалуйста, попробуйте повторить попытку позже',
  RevitExtractorError: 'Ошибка импорта, пожалуйста, попробуйте повторить попытку позже'
};
export var importErrorTooltipCodeMap = {
  AxisError: 'Модель не содержит элементов.',
  Role3DError: 'Не настроен 3D вид для модели.',
  StructureError: 'В модели ожидается структура: категория->семейство->типоразмер->элемент[->вложенный элемент]',
  ForgeError: 'Ошибка импорта',
  RevitExtractorError: 'Ошибка импорта'
};
export var importErrorTooltipCodeDescriptionMap = {
  AxisError: 'Пожалуйста, внесите изменения в модель и попробуйте еще раз.',
  Role3DError: 'Пожалуйста, внесите изменения в модель и попробуйте еще раз.',
  StructureError: 'Пожалуйста, внесите изменения в модель и попробуйте еще раз.',
  ForgeError: 'Пожалуйста, попробуйте еще раз.',
  RevitExtractorError: 'Пожалуйста, попробуйте еще раз.'
};